import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { Button, Label } from '../../atoms';
import ReportingDetailsThemesOrganism from '../../organisms/ReportingDetailsThemesOrganism';
import BaseTemplate from '../BaseTemplate';

import styles from './ReportingDetailsThemesTemplate.module.css';

export interface ReportingDetailsThemesTemplateProps {
  data: ThemeResponseDto[];
  handleDeleteTheme: (id: string) => void;
}

const ReportingDetailsThemesTemplate: FC<
  ReportingDetailsThemesTemplateProps
> = ({ data, handleDeleteTheme }) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Progress Reporting - Themes" size="lg" />
        <Button
          variant={'dark'}
          onClick={() => navigate('/reporting-details/themes/add')}
        >
          Add Theme
        </Button>
      </div>
      <ReportingDetailsThemesOrganism
        data={data}
        handleDeleteTheme={handleDeleteTheme}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsThemesTemplate;
